<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          v-if="
            mode == 0 &&
              (bank == null ||
                bank.bankId == -1 ||
                branch == null ||
                branch.BranchId == -1)
          "
          class="mr-1"
          small
          color="primary"
          v-on="tooltip"
          dark
          @click="chooseFilters"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          v-else
          class="mr-1"
          small
          color="primary"
          dark
          v-on="{ ...tooltip }"
          v-on:click="() => (dialog = !dialog)"
        >
          <v-icon>{{
            `${mode === 0 ? "mdi-plus" : "mdi-pencil-outline"}`
          }}</v-icon>
        </v-btn>
      </template>
      <span>{{
        `${
          mode === 0
            ? $t("referenceBooks.devices.Create")
            : $t("referenceBooks.devices.Edit")
        }`
      }}</span>
    </v-tooltip>
    <DragForm v-model="dialog">
      <v-card width="800">
        <v-card-title>
          <span class="headline">{{
            `${
              mode === 0
                ? $t("referenceBooks.devices.Create")
                : $t("referenceBooks.devices.Edit")
            }`
          }}</span>
        </v-card-title>
        <v-card-text style="overflow-y: auto;  max-height: 400px">
          <v-container>
            <v-row class="mr-4 ml-4">
              <v-text-field
                v-model="currentDevice.bankName"
                :disabled="true"
                :label="$t('referenceBooks.banks.Bank') + '*'"
                required
              />
            </v-row>
            <v-row class="mr-4 ml-4">
              <v-text-field
                v-model="currentDevice.branchName"
                :disabled="true"
                :label="$t('referenceBooks.branches.Branch') + '*'"
                required
              />
            </v-row>
            <v-row class="mr-4 ml-4">
              <v-text-field
                v-model="currentDevice.deviceName"
                :label="$t('referenceBooks.devices.Name') + '*'"
                required
                :error-messages="deviceErrorMessage"
                v-on:blur="
                  () => {
                    this.deviceWasBlurred = true;
                  }
                "
              ></v-text-field>
            </v-row>

            <v-row class="mr-4 ml-4">
              <v-autocomplete
                :label="$t('referenceBooks.devices.DeviceTypeName') + '*'"
                v-model="currentDevice.deviceTypeId"
                :disabled="mode === 1"
                :key="'deviceTypeId'"
                :item-text="'deviceTypeName'"
                :item-value="'deviceTypeId'"
                :items="deviceTypes"
                :error-messages="deviceTypesErrorMessage"
                v-on:change="onDeviceTypeChange"
                v-on:click="
                  () => {
                    this.deviceTypesWasBlurred = true;
                  }
                "
                required
              />
            </v-row>
            <v-row class="mr-4 ml-4">
              <v-text-field
                :label="$t('referenceBooks.devices.SN') + '*'"
                v-model="currentDevice.sn"
                :error-messages="snErrorMessage"
                v-on:blur="
                  () => {
                    this.snWasBlurred = true;
                  }
                "
                required
              />
            </v-row>
            <v-row class="mr-4 ml-4">
              <v-text-field
                :label="$t('referenceBooks.devices.Link') + '*'"
                v-model="currentDevice.link"
                :error-messages="linkErrorMessage"
                v-on:blur="
                  () => {
                    this.linkWasBlurred = true;
                  }
                "
                required
              />
            </v-row>
            <v-row class="mr-4 ml-4">
              <v-text-field
                :label="$t('referenceBooks.devices.Alias') + '*'"
                v-model="currentDevice.alias"
                :error-messages="aliasErrorMessage"
                v-on:blur="
                  () => {
                    this.aliasWasBlurred = true;
                  }
                "
                required
              />
            </v-row>
          </v-container>
          <small class="mr-4 ml-4"
            >*{{ $t("referenceBooks.requiredFields") }}</small
          >
        </v-card-text>
        <v-card-actions class="d-flex align-start">
          <v-spacer></v-spacer>
          <v-checkbox
            v-model="attachDialogOpened"
            color="blue darken-1"
            dense
            class="shrink mr-8"
            hide-details
            :label="$t('referenceBooks.products.Edit')"
          ></v-checkbox>
          <v-btn color="blue darken-1" text @click="dialog = false">{{
            $t("Close")
          }}</v-btn>

          <v-btn
            v-if="mode === 0"
            color="blue darken-1"
            text
            @click="createDevice"
            >{{ $t("Create") }}</v-btn
          >
          <v-btn v-else color="blue darken-1" text @click="saveDevice">{{
            $t("Save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </DragForm>
  </div>
</template>

<script>
import DragForm from '@/components/Forms/DragForm.vue';
import Vue from 'vue';
import { notifyError, notifySuccess } from '@/services/notifications';
export default {
  components: {
    DragForm,
  },
  name: 'DeviceDialog',
  props: {
    mode: {
      type: Number,
      defaultItem: 0,
    },
    device: {
      type: Object,
      default: null,
    },
    bank: {
      type: Object,
      default: null,
    },
    branch: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      currentDevice: {
        deviceName: '',
        deviceTypeId: -1,
        deviceTypeName: '',
        sn: '',
        bankId: -1,
        bankName: '',
        branchId: '',
        branchName: '',
        link: '',
        alias: '',
      },
      dialog: false,
      attachDialogOpened: false,
      deviceTypes: [],
      bankName: '',

      busyValues: {
        Name: [],
        Alias: [],
        Link: [],
        SN: [],
      },
      needCheck: [
        { propName: 'alias', type: 0, busyName: 'Alias' },
        { propName: 'link', type: 0, busyName: 'Link' },
        { propName: 'sn', type: 0, busyName: 'SN' },
        { propName: 'deviceTypeId', type: 1, busyName: 'DeviceType' },
        { propName: 'deviceName', type: 0, busyName: 'Name' },
      ],
      branchWasBlurred: false,
      deviceWasBlurred: false,
      deviceTypeWasBlurred: false,
      snWasBlurred: false,
      linkWasBlurred: false,
      aliasWasBlurred: false,
      executeButtonClick: false,
    };
  },
  computed: {
    propertiesResponse() {
      return {
        Name: this.$t('referenceBooks.devices.Name'),
        Link: this.$t('referenceBooks.devices.Link'),
        Alias: this.$t('referenceBooks.devices.Alias'),
        SN: this.$t('referenceBooks.devices.SN'),
        DeviceType: this.$t('referenceBooks.devices.DeviceTypeName'),
      };
    },
    branchErrorMessage() {
      if (this.currentDevice.branchId < 1)
        return this.$t('validations.notEmpty');

      return '';
    },
    aliasErrorMessage() {
      const name = this.currentDevice.alias;
      const check =
        this.executeButtonClick ||
        this.aliasWasBlurred ||
        (name != null && name.length != 0);

      if (!check) return '';

      return this.checkText(name, 'Alias');
    },
    deviceErrorMessage() {
      const name = this.currentDevice.deviceName;
      const check =
        this.executeButtonClick ||
        this.deviceWasBlurred ||
        (name != null && name.length != 0);

      if (!check) return '';

      return this.checkText(name, 'Name');
    },
    deviceTypesErrorMessage() {
      const check =
        this.executeButtonClick ||
        this.deviceTypesWasBlurred ||
        (name != null && name.length != 0);

      if (!check) return '';

      return this.checkId(this.currentDevice.deviceTypeId);
    },
    snErrorMessage() {
      const name = this.currentDevice.sn;
      const check =
        this.executeButtonClick ||
        this.snWasBlurred ||
        (name != null && name.length != 0);

      if (!check) return '';

      return this.checkText(name, 'SN');
    },
    linkErrorMessage() {
      const name = this.currentDevice.link;
      const check =
        this.executeButtonClick ||
        this.linkWasBlurred ||
        (name != null && name.length != 0);

      if (!check) return '';

      return this.checkText(name, 'Link');
    },
  },
  watch: {
    dialog(flag) {
      if (flag) {
        this.loadDefault();
        if (this.mode === 0) this.loadModeNull();
        else this.loadModeOne();
      } else this.clear();
    },
  },
  methods: {
    onDeviceTypeChange() {
    },
    checkFields() {
      let result = true;

      this.needCheck.forEach((field) => {
        let errors;
        if (field.type == 0)
          errors = this.checkText(
            this.currentDevice[field.propName],
            field.busyName
          );
        else errors = this.checkId(this.currentDevice[field.propName]);

        if (errors != null && errors != '') {
          this.showMessage(
            `${this.$t('ErrorInField')}: ${
              this.propertiesResponse[field.busyName]
            }`,
            errors,
            'error'
          );
          result = false;
        }
      });

      return result;
    },
    checkId(id) {
      if (id < 1) return this.$t('validations.notEmpty');

      return '';
    },
    checkText(value, ind = null) {
      if (value == null || value.length == 0)
        return this.$t('validations.notEmpty');

      if (ind != null) {
        if (this.busyValues[ind] != null && this.busyValues[ind].length != 0)
          if (this.busyValues[ind].indexOf(value, 0) != -1)
            return this.$t('errorsMessages.BusyName');
      }

      return '';
    },
    clear() {
      this.currentDevice = {
        deviceName: '',
        deviceTypeId: -1,
        deviceTypeName: '',
        sn: '',
        branchId: '',
        branchName: '',
        link: '',
        alias: '',
      };

      this.bankName = '';

      this.branchWasBlurred = false;
      this.deviceWasBlurred = false;
      this.deviceTypeWasBlurred = false;
      this.snWasBlurred = false;
      this.linkWasBlurred = false;
      this.aliasWasBlurred = false;
      this.executeButtonClick = false;
    },
    loadDefault() {
      this.setBank();
      this.getDeviceTypes();
    },
    setBank() {
      if (this.bank != null) this.bankName = this.bank.bankName;
    },
    loadModeNull() {
      if (this.bank != null) {
        this.currentDevice.bankId = this.bank.bankId;
        this.currentDevice.bankName = this.bank.bankName;
      }
      if (this.branch != null) {
        this.currentDevice.branchId = this.branch.branchId;
        this.currentDevice.branchName = this.branch.name;
        this.currentDevice.deviceTypeId = this.deviceTypes[0].deviceTypeId;
      }
    },
    loadModeOne() {
      if (this.device != null) {
        Object.assign(this.currentDevice, this.device);
      }
    },
    getDeviceTypes() {
      this.$axios.deviceTypes
        .get()
        .then((response) => response.data)
        .then((json) => {
          this.deviceTypes = json;
          if (this.mode === 0) {
            this.currentDevice.deviceTypeId = this.deviceTypes[0].deviceTypeId;
          }
        })
        .catch((error) => console.error(error));
    },
    chooseFilters() {
      if (this.bank == null || this.bank.bankId == -1)
        this.showMessage(
          this.$t('Error'),
          this.$t('referenceBooks.banks.ChooseSomeBank'),
          'error'
        );
      else
        this.showMessage(
          this.$t('Error'),
          this.$t('referenceBooks.branches.ChooseSomeBranch'),
          'error'
        );
    },
    createDevice() {
      this.executeButtonClick = true;

      if (!this.checkFields()) return;

      this.$axios.devices
        .post({
          deviceId: 0,
          deviceName: this.currentDevice.deviceName,
          deviceTypeId: this.currentDevice.deviceTypeId,
          sn: this.currentDevice.sn,
          branchId: this.currentDevice.branchId,
          link: this.currentDevice.link,
          alias: this.currentDevice.alias,
          deviceStateId: 0,
          deviceStateName: null,
        })
        .then((response) => {
          if (response.status == 200) {
            const id = response.data;
            notifySuccess(
              '',
              this.$t('Messages.DeviceWasCreated', [
                this.currentDevice.deviceName,
              ])
            );
            this.$emit(
              'created',
              response.status,
              this.currentDevice.deviceName,
              id,
              this.attachDialogOpened
            );
            this.dialog = false;
          }
        })
        .catch((error) => {
          notifyError(
            '',
            this.$t('Messages.ErrorOccuredWhileCreatingDevice', [
              this.currentDevice.deviceName,
            ])
          );
          this.catchErrors(error);
        });
    },
    catchErrors(error, errorHeader = '') {
      const status = error.response.status;
      const data = [error.response.data];

      if (status === 400 || status === 401) {
        for (let i = 0; i < data.length; i++)
          this.handlingError(data[i], errorHeader, error);
      } else {
        this.onUnknownError(error);
      }
    },
    handlingError(data, errorHeader, error) {
      switch (data.errorType) {
      case 'IS_BUSY':
        this.onBusy(data.property, data.value);
        break;
      case 'NO_RIGHTS':
        this.onNoRigths(errorHeader);
        break;
      default:
        this.onUnknownError('error', error);
        break;
      }
    },
    onBusy(property, value) {
      this.busyValues[property].push(value);
      const errorInField = `${this.$t('ErrorInField')}: ${
        this.propertiesResponse[property]
      }`;

      this.showMessage(
        errorInField,
        this.$t('errorsMessages.BusyName'),
        'error'
      );
    },
    onNoRigths(errorHeader = '') {
      this.showMessage(
        `${errorHeader === '' ? this.$t('Error') : errorHeader}`,
        this.$t('errorsMessages.NoRights'),
        'error'
      );
    },
    saveDevice() {
      this.executeButtonClick = true;

      if (!this.checkFields()) return;

      const data = this.currentDevice;

      this.$axios.devices
        .put(this.currentDevice.deviceId, this.currentDevice)
        .then((response) => {
          notifySuccess(
            '',
            this.$t('Messages.DeviceWasEdited', [data.deviceName])
          );
          this.$emit('saved', response.status, data);
          this.dialog = false;
        })
        .catch((error) => {
          console.error(error);

          notifyError(
            '',
            this.$t('Messages.ErrorOccuredWhileEditingDevice', [
              data.deviceName,
            ])
          );
          this.catchErrors(error);
        });

      this.dialog = false;
    },
    showMessage(title, text, type = '') {
      Vue.notify({
        group: 'notif',
        title: title,
        text: text,
        type: type,
      });
    },
  },
};
</script>
